import { trackEvent } from 'shared/app/utils/uo-tracking';

/**
 * @returns {Promise<void>} The event has been sent.
 */
export const trackAuthLoginClick = () => trackEvent('AUTH_LOGIN_CLICK');

/**
 * @returns {Promise<void>} The event has been sent.
 */
export const trackAuthLoginError = () => trackEvent('AUTH_LOGIN_ERROR');

/**
 * @returns {Promise<void>} The event has been sent.
 */
export const trackAuthLoginSuccess = () => trackEvent('AUTH_LOGIN_SUCCESS');
